import { useEffect, useState } from "react";
import Content from "../../../../../layout/Content";
import billingApi from "@serie3/freelancesplaceapi/api/finance/out";
import FinanceApi from "@serie3/freelancesplaceapi/api/finance/out";
import TableRowBills from "../../TableRowBills";
import BillView from "../../modals/BillView";
import BillIn from "../../BillIn";
import BillDropzone from "./SubComponents/BillDropzone";
import BillingData from "./SubComponents/BillingData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation,faSpinner, faArrowDownWideShort, faArrowUpWideShort, faWrench, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { Modal, Row, Form } from "react-bootstrap";
import FinanceHeader from "../../FinanceHeader";
import listHandler from "@serie3/common/Domain/listHandler";
import crudApi from "@serie3/common/api/crudApi";
import { useFormik } from "formik";
import FinanceForm from "@serie3/freelancesplaceapi/Form/Billing/FinanceForm";
import Finance from "@serie3/freelancesplaceapi/Entity/Billing/Finance";
import { btn, btnHoverStyle } from "../../../../../layout/Buttons/buttonStyles";

const FixAllModal = ({ bills, startIndex, onClose, onSaved }) => {
  const [currentIndex, setCurrentIndex] = useState(startIndex ?? 0);
  const [bill, setBill] = useState(null);
  const [address, setAddress] = useState(null);
  const [contact, setContact] = useState(null);
  const [loadingBill, setLoadingBill] = useState(false);
  const [analyzing, setAnalyzing] = useState(false);
  const [showNew, setShowNew] = useState(false);

  const formik = useFormik({
    initialValues: Finance,
    onSubmit: async (values) => {
      const { tax, ...valuesToSend } = values;
      await FinanceApi.edit("bills", "in", JSON.stringify(valuesToSend));
      onSaved();
    },
  });

  const loadBill = async (idx) => {
    if (!bills[idx]) return;
    setLoadingBill(true);
    const b = await billingApi.showBill("bills", "in", bills[idx].id);
    setBill({ ...b, eingang: true });
    setAddress(b.fixed_address);
    setContact(b.kunde || b.person || null);
    formik.setValues(FinanceForm.setEditData(b));
    setLoadingBill(false);
  };

  useEffect(() => {
    loadBill(currentIndex);
  }, [currentIndex]);

  const go = (delta) => {
    const next = currentIndex + delta;
    if (next >= 0 && next < bills.length) setCurrentIndex(next);
  };

  const total = bills.length;

  return (
    <Modal show onHide={onClose} size="xl" contentClassName="modal-pipeline-content" dialogClassName="modal-fullwidth">
      <style>{`
        .modal-fullwidth .modal-dialog { max-width: 95vw; width: 95vw; }
        .modal-fullwidth .modal-content { min-height: 85vh; display: flex; flex-direction: column; background: transparent !important; border: none !important; box-shadow: none !important; }
      `}</style>

      {/* Header */}
      <div style={{ background: "linear-gradient(135deg, #e65100 0%, #bf360c 100%)", padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", borderRadius: "14px 14px 0 0", flexShrink: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <div>
            <div style={{ fontWeight: 800, fontSize: "1rem", color: "#fff", display: "flex", alignItems: "center", gap: "8px" }}>
              <FontAwesomeIcon icon={faWrench} />
              Fix All
            </div>
            <div style={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.75)", marginTop: "2px" }}>
              {bill ? `#${bill.rechnungs_nummer || bill.id} · ${bill.betreff || "No subject"}` : "Loading…"}
            </div>
          </div>
        </div>
        <button onClick={onClose} style={{ background: "rgba(255,255,255,0.15)", border: "none", borderRadius: "8px", width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#fff", fontSize: "1rem" }}>✕</button>
      </div>

      {/* Body */}
      <div style={{ flex: 1, overflowY: "auto", padding: "16px 24px", background: "#f4f6fa" }}>
        {loadingBill || !bill ? (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "300px", gap: "12px", color: "#9e9e9e" }}>
            <FontAwesomeIcon icon={faSpinner} spin style={{ fontSize: "1.4rem" }} />
            <span>Loading bill…</span>
          </div>
        ) : (
          <Form>
            <Row>
              <BillDropzone
                bill={bill}
                uploadUrl={"/finance/in/bills/edit"}
                previewUrl={"/finance/in/bills/filePreview/" + bill.id}
                formik={formik}
                setAnalyzing={setAnalyzing}
              />
              <BillingData
                formik={formik}
                bill={bill}
                setShowNew={setShowNew}
                address={address}
                setAddress={setAddress}
                contact={contact}
                setContact={setContact}
                loading={loadingBill || analyzing}
                onContactUpdated={async () => {
                  const fresh = await billingApi.showBill("bills", "in", bill.id);
                  setBill({ ...fresh, eingang: true });
                  setAddress(fresh.fixed_address);
                  setContact(fresh.kunde || fresh.person || null);
                  formik.setFieldValue("kunde", fresh.kunde ? { id: fresh.kunde.id } : null);
                  formik.setFieldValue("person", fresh.person ? { id: fresh.person.id } : null);
                }}
              />
            </Row>
          </Form>
        )}
      </div>

      {/* Footer */}
      <div style={{ background: "#fff", borderTop: "1px solid #e8edf5", padding: "12px 24px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 0 14px 14px", flexShrink: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <button
            onClick={() => go(-1)}
            disabled={currentIndex === 0}
            style={{ padding: "8px 14px", borderRadius: "8px", border: "1px solid #e0e0e0", background: currentIndex === 0 ? "#f5f5f5" : "#fff", color: currentIndex === 0 ? "#c0c0c0" : "#424242", cursor: currentIndex === 0 ? "default" : "pointer", display: "inline-flex", alignItems: "center", gap: "6px", fontWeight: 600, fontSize: "0.85rem" }}
          >
            <FontAwesomeIcon icon={faChevronLeft} /> Prev
          </button>
          <span style={{ padding: "8px 16px", background: "#f8f9fb", borderRadius: "8px", fontSize: "0.85rem", fontWeight: 700, color: "#424242", minWidth: "80px", textAlign: "center" }}>
            {currentIndex + 1} / {total}
          </span>
          <button
            onClick={() => go(1)}
            disabled={currentIndex === total - 1}
            style={{ padding: "8px 14px", borderRadius: "8px", border: "1px solid #e0e0e0", background: currentIndex === total - 1 ? "#f5f5f5" : "#fff", color: currentIndex === total - 1 ? "#c0c0c0" : "#424242", cursor: currentIndex === total - 1 ? "default" : "pointer", display: "inline-flex", alignItems: "center", gap: "6px", fontWeight: 600, fontSize: "0.85rem" }}
          >
            Next <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
    </Modal>
  );
};

const NeedsAttention = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [bill, setBill] = useState();
  const [showRowError, setShowRowError] = useState(false);
  const [sortAsc, setSortAsc] = useState(false);
  const [showFixAll, setShowFixAll] = useState(false);

  const loadData = async () => {
    setLoading(true);
    const res = await crudApi.getAll("finance/in/import/needattention");
    setData(res?.data?.finanzvorgang ?? res?.data ?? []);
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const sortedData = [...data].sort((a, b) =>
    sortAsc
      ? new Date(a.datum || 0) - new Date(b.datum || 0)
      : new Date(b.datum || 0) - new Date(a.datum || 0)
  );

  const deleteFromList = async (index, apiCall) => {
    listHandler.deleteFromList(index, apiCall, setData, sortedData, setShowRowError);
  };

  const onMarkPaid = (index) => {
    setData((prev) => prev.map((b, i) => i === index ? { ...b, geldeingang: true } : b));
  };

  const Title = () => (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
      <FontAwesomeIcon icon={faTriangleExclamation} style={{ color: "#e65100" }} />
      Needs Attention
    </span>
  );

  const FixAllButton = () => (
    <>
      <style>{btnHoverStyle}</style>
      <button
        className="btn-modern"
        style={{ ...btn.base, background: "#e65100", color: "#fff", border: "none" }}
        onClick={() => setShowFixAll(true)}
        disabled={sortedData.length === 0}
      >
        <FontAwesomeIcon icon={faWrench} /> Fix All
      </button>
    </>
  );

  return (
    <>
      <BillView show={show} bill={bill} setShow={setShow} direction="in">
        <BillIn bill={bill} type="bills" />
      </BillView>

      {showFixAll && sortedData.length > 0 && (
        <FixAllModal
          bills={sortedData}
          startIndex={0}
          onClose={() => setShowFixAll(false)}
          onSaved={() => loadData()}
        />
      )}

      <FinanceHeader direction="in" hideYearPicker />

      <Content Title={Title} AdditionalButtons={FixAllButton}>
        <div style={{ marginBottom: "12px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontSize: "0.82rem", color: "#9e9e9e" }}>
            Bills with <strong style={{ color: "#e65100" }}>no file attached</strong> or marked as <strong style={{ color: "#1a73e8" }}>imported</strong>
          </div>
          <button
            type="button"
            onClick={() => setSortAsc((v) => !v)}
            style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "5px 10px", background: "#f5f5f5", border: "none", borderRadius: "8px", fontWeight: 600, fontSize: "0.8rem", color: "#616161", cursor: "pointer" }}
          >
            <FontAwesomeIcon icon={sortAsc ? faArrowUpWideShort : faArrowDownWideShort} style={{ fontSize: "0.75rem" }} />
            {sortAsc ? "Oldest first" : "Newest first"}
          </button>
        </div>

        <div style={{ overflowX: "auto", minHeight: "40vh" }}>
          {loading ? (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "60px", gap: "12px", color: "#9e9e9e" }}>
              <div style={{ width: "24px", height: "24px", borderRadius: "50%", border: "3px solid #e8f0fe", borderTopColor: "#1a73e8", animation: "spin 0.8s linear infinite" }} />
              <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            </div>
          ) : (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  {["Bill No.", "Customer", "Status", "Net", "Tax", "Gross", ""].map((h, i) => (
                    <th key={i} style={{ padding: "10px 12px", fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#9e9e9e", background: "#f8f9fb", borderBottom: "1px solid #f0f0f0", whiteSpace: "nowrap", textAlign: i >= 3 && i <= 5 ? "right" : "left", width: i === 6 ? "40px" : undefined }}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sortedData.length === 0 ? (
                  <tr>
                    <td colSpan={7} style={{ textAlign: "center", padding: "48px 0", color: "#bdbdbd", fontSize: "0.92rem" }}>
                      No bills need attention.
                    </td>
                  </tr>
                ) : sortedData.map((bill, index) => (
                  <TableRowBills
                    key={bill.id ?? index}
                    index={index}
                    bill={bill}
                    setShow={setShow}
                    setBill={setBill}
                    direction="in"
                    type="bills"
                    deleteFunction={deleteFromList}
                    onMarkPaid={onMarkPaid}
                  />
                ))}
              </tbody>
            </table>
          )}
        </div>
      </Content>
    </>
  );
};

export default NeedsAttention;
